import React, { useEffect, useState } from 'react';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import resourceIcon from "../../assets/images/resource_icon.svg";
import levelIcon from "../../assets/images/level_icon.svg";
import timeIcon from "../../assets/images/time_icon.svg";
import calendarIcon from "../../assets/images/calendar_icon.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import Table from "../../components/selectTable";
import { Icon } from '@iconify/react';
import {
  GridPageChangeEvent,
  GridPagerSettings,
} from "@progress/kendo-react-grid";
import { Error } from "@progress/kendo-react-labels";
import { useNavigate } from 'react-router-dom';
import { checkPriority, convertMilliSecToDateNew, priorityClass } from '../../utils/EllowUtils';
import SearchBar from '../../components/searchbar';
import ConfirmationModal from '../../modal/confirmation/confirmationModal';

interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}




function ApplyPositionsTable(props: any) {
  
  const jobId = props.jobId
  const [error, setError] = useState<string>()
  const [count, setCount] = useState<number>(0)
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false)
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number , priority:number, experienceRange: {min: number , max: number}  , contractDuration : string , contractStartDate: number , minimumBudget: any , maximumBudget: any ,
      billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}], postPosition: any, title: string
  }>({
    resourceCount: 0, priority:5, experienceRange: {min: 0 , max: 12}  , contractDuration: "" , contractStartDate: 0 , minimumBudget: 0 , maximumBudget: 0 ,
      billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}], postPosition:{}, title:''
  })

  const [selectedCandidates, setSelectedCandidates] = useState([])
  let navigate = useNavigate()


  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state, setState] = useState<AppState>(createState(0, 25, props.data));

  useEffect(() => {

    setState(createState(state.skip, state.pageSize, props.data));
    setJobMetadata(props.jobMetadata)  

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.total, props.data, props.jobMetadata, props.filtervalues])


  const pageChange = (event: GridPageChangeEvent) => { 
    setState(createState(event.page.skip, event.page.take, props.data));
    
    props.pageSize(event.page.take, event.page.skip) 
  }
  
  const pageSize = (pageSize:any, pageNumber: number) => { 
    props.pageSize(pageSize, pageNumber)
  }
  

  const onSelection =  (data: any) => {
    setSelectedCandidates(data) 
    setCount(data.length)
    setError('')
    
  }

  const createResource = () => {
    navigate('/createResources', { state: { jobId: jobId, positionName: jobMetadata && jobMetadata.title, companyName: jobMetadata && jobMetadata.postPosition.companyName } })
    localStorage.setItem('selectedCandidates', JSON.stringify(selectedCandidates))
  }

  const submitResource = () => {
    if (selectedCandidates && selectedCandidates.length > 0) {
      props.onSubmit(selectedCandidates)
    }else {
      setError('Select atleast one resource')
    }
  }

  const onRowClick = (data: any) => {
    setSelectedCandidates(data)
  }

  const checkSelected = () => {
    if (selectedCandidates && selectedCandidates.length > 0) {
      setConfirmationModal(true)
    }
    else {
      createResource()
    }
  }

    return (
      <>
        {confirmationModal && <ConfirmationModal apply={selectedCandidates} submit={() => {createResource(); setConfirmationModal(false) }} onClose={() => setConfirmationModal(false)} />}
        <div className="table-content-wrapper">
          <h3 className="headWithLabel">
            Job Description<label className={jobMetadata && priorityClass(jobMetadata.priority)}>{jobMetadata && checkPriority(jobMetadata.priority) }</label>
          </h3>
          <div className={Styles.jobStatusWrap}>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={resourceIcon} />
              </figure>
              <figcaption>Resources Required</figcaption>
              <h2>{jobMetadata && jobMetadata.resourceCount}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={levelIcon} />{" "}
              </figure>
              <figcaption>Experience Level</figcaption>
          <h2>{jobMetadata && jobMetadata.experienceRange  ?  jobMetadata.experienceRange.min +" - "+ jobMetadata.experienceRange.max +' Years' : 'Not Mentioned'}</h2>
              
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={timeIcon} />
              </figure>
              <figcaption>Contract Duration</figcaption>
              <h2>{jobMetadata && jobMetadata.contractDuration !== '' ? <h2>{jobMetadata.contractDuration}</h2> : 'Not Mentioned' }</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={calendarIcon} />
              </figure>
              <figcaption>Start Date</figcaption>
              <h2>{jobMetadata && jobMetadata.contractStartDate && jobMetadata.contractStartDate !== 0 ? convertMilliSecToDateNew(jobMetadata.contractStartDate) : 'Immediate'}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={crownIcon} />
              </figure>
              <figcaption>Job Role</figcaption>
              <h2><h2>{jobMetadata && jobMetadata.jobRole.name}</h2></h2>
            </div>
            
          </div>
        </div>
        <section className={Styles.dashboardWrapper}>
          <div className="table-content-wrapper">
          <div className={Styles.resourceHead}>
            <div className="tableHead">
                <div className="tableTitle">
                  <h2>Resources</h2>
                  <p>{`${count} Resources Selected`}</p>
                </div>
                <Button onClick={submitResource} variant="primary" size="small">
                Apply for this Position
              </Button>
            </div> 
            <div className={Styles.resourceSearch}>
                <SearchBar searchChange={props.searchChange} filterKey={true} />
                <div className={Styles.resourceAdd}>
                  <button onClick={checkSelected} className="link-btn">
                  <Icon icon="ic:round-plus" /> Add New Resource
                  </button>
                </div>
            </div>
          </div>
          <Error>{error}</Error>
           
          <Table data={props.data} type={'positions'} total={props.total} state={state} pageChange={pageChange}  pageSize={pageSize} onSelection={onSelection} onRowClick={onRowClick}/>
          </div>
        </section>
      </>
    );
    }
    
    export default ApplyPositionsTable
